import { match } from 'ts-pattern';
import { RectangularPlate as V6RectangularPlate, SquarePlate as V6SquarePlate } from '../__generated/model/versions/v6.js';
export const migrateToV7 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().when(V6SquarePlate.is, (plate)=>({
                ...plate,
                hasBend: false
            })).when(V6RectangularPlate.is, (plate)=>({
                ...plate,
                hasBend: false
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v7.js.map